import React from 'react';

const CashChunkySvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path d="M9.4 8.8c0-1.1 1-1.9 2.7-1.9 1.8 0 2.4.9 2.5 2.1h2.2c-.1-1.7-1.8-3.4-3.9-3.9V3h-2v2.1C9 5.5 7.1 6.8 7.1 8.8c0 2.3 1.9 3.5 4.7 4.1 2.5.6 3 1.5 3 2.4 0 .7-.5 1.8-2.7 1.8-2.1 0-2.9-.9-3-2.1H6.9c.1 2.2 2.1 3.4 4 3.8V21h2v-2.1c1.9-.4 4.2-1.5 4.2-3.6 0-2.8-2.4-3.8-4.7-4.4s-3-1.2-3-2.1z" />
    </svg>
);

CashChunkySvg.displayName = 'CashChunkySvg';
export default CashChunkySvg;
